import Axios from 'axios';
import { HTTP_RESPONSE_CODE_VALIDATION_ERROR } from '@/utils/constants/api/responseCode';
/** isAxiosError のラップ関数 */
export const isAxiosError = (error) => Axios.isAxiosError(error);
/** APIバリデーションエラーの型定義ガード */
export const isApiValidationError = (exception) => {
    var _a;
    return Axios.isAxiosError(exception) &&
        ((_a = exception.response) === null || _a === void 0 ? void 0 : _a.status) === HTTP_RESPONSE_CODE_VALIDATION_ERROR;
};
